import QRCode from 'easyqrcodejs';

$(() => {
	//	QRCODE
	$('.qr-code-container').each(function(index, elem) {
		const dataValue = $(elem).attr('data-qr-value');
		const sizeValue = $(elem).attr('data-qr-size');
		var sizeData = parseInt(sizeValue);
		
		new QRCode(elem, {
			text: dataValue ? atob(dataValue) : document.URL,
			width: sizeData,
			height: sizeData,
			colorDark: '#000',
			colorLight: '#FFF',
			correctLevel: QRCode.CorrectLevel.M
		});

	});	   
});